import SettingsIcon from './SettingsIcon'
export default SettingsIcon


// WEBPACK FOOTER //
// ./src/modules/ControlWrapper/SettingsIcon/index.js